import styled from "styled-components"

export const ArrowStyles = styled.img`
  position: relative;
  left: 20px;

  @media only screen and (max-width: 1077px) {
    display: none;
  }
`
